import { message } from 'antd';
// import { message, Alert } from 'antd';

function showError(error: { code: number }, text: string) {
  // eslint-disable-next-line
  const node = (
    <div>
      <div>{text}</div>
      <div>Reason: ${error.code} </div>
    </div>
  );

  // message.error(node);
  showErrorText(`${text} Reason: ${error.code}`);
}

function showErrorText(text: string) {
  // message.error(<Alert type='error' message={text} style={{display: 'inline-block'}}></Alert>, 5);
  message.error(text, 5);
}

function showSuccessText(text: string, closeAfter = 5) {
  message.success(text, closeAfter);
  // message.success(<Alert type='success' message={text} style={{display: 'inline-block'}}></Alert>, 5);
}

function handleResponseError(error: unknown, closeAfter = 3) {
  function hasMessage(error: unknown): error is { message: string } {
    return typeof error === 'object' && error != null && 'message' in error;
  }

  if (error && typeof error == 'object') {
    if (hasMessage(error)) {
      message.error(error.message, closeAfter);
    }
  } else {
    message.error('Internal Server Error, please try again later.', closeAfter);
  }
}

export default {
  showError,
  showErrorText,
  showSuccessText,
  handleResponseError,
};
